import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, RadarController } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, RadarController);

const ComparisonCandidateAttemptRadarChart = ({ enduser_title, enduser_score1, enduser_score2, top_four_scores1, top_four_scores2 }) => {

    if (!top_four_scores1) {
        return <div style={{ width: 200, height: 200, opacity: 0 }}> - </div>;
    }

    const baseLabels = Object.keys(top_four_scores1).map(
        score => score.charAt(0).toUpperCase() + score.slice(1)
    );

    const labels = [enduser_title, ...baseLabels];

    const baseScores1 = Object.values(top_four_scores1);
    const baseScores2 = top_four_scores2 ? Object.values(top_four_scores2) : [];

    const scores1 = [enduser_score1, ...baseScores1];
    const scores2 = [enduser_score2, ...baseScores2];

    const radarData = {
        labels,
        datasets: [
            {
                data: scores1,
                backgroundColor: '#36F7C11A', // 10% opacity
                borderColor: '#36F7C1',
                pointBackgroundColor: '#36F7C1',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#36F7C1',
            },
            ...(top_four_scores2 ? [{
                data: scores2,
                backgroundColor: '#00C7F21A', // 10% opacity
                borderColor: '#00C7F2',
                pointBackgroundColor: '#00C7F2',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#00C7F2',
            }] : [])
        ],
    };

    const radarOptions = {
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                mode: 'nearest',
                intersect: false,
            },
        },
        scales: {
            r: {
                beginAtZero: true,
                max: 90,
                min: 20,
                ticks: {
                    display: false,
                },
                pointLabels: {
                    font: {
                        size: 15,
                    },
                    color: '#2D2D2D',
                },
            },
        },
        height: 300,
        maintainAspectRatio: false
    };

    return (
        <Radar data={radarData} options={radarOptions} />
    );
};

export default ComparisonCandidateAttemptRadarChart;